import Api from './BaseRequest';

const Get = () => {
    return Api.Get('/api/teaching_card')
};

export default {
    Get
};
